<!-- 购买题库 -->
<template>
<van-popup v-model="specialTopicBuyDialogVisible" class="buy-popup list-popup" position="right">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">购买题库</div>
    </div>
    <el-scrollbar class="content-scroll">
        <div class="module-name">
            <div class="name">题库名称</div>
        </div>
        <div class="banklist">
            <div class="bank-item" @click="handleChangeExamcode(item, index)" v-for="(item, index) in subjectlist" :class="{active: params.examcode === item.examcode}" :key="item.examcode">{{item.label}}</div>
        </div>
        <div class="module-name">
            <div class="name">开通科目</div>
        </div>
        <div class="subjectlist">
            <div class="subject-item" v-for="(item) in subjectlist[currentTopicIndex].subjectList" :key="item.subjectcode">
                <div class="subject-item-label" @click="handleChangeSubject(item)" :class="{active: item.subjectcode === params.subjectcodes}">{{ item.label }}</div>
            </div>
        </div>
        <div class="module-name">
            <div class="name">开通时长</div>
        </div>
        <div class="expiredate">
            有效期：12个月
            <img class="select-icon" :src="require('@/common/images/mSpecialTopic/select_icon.png')" />
        </div>
    </el-scrollbar>
    <div class="order-info-handle">
        <div class="ordermoney">
            <div class="label">支付金额：</div>
            <div class="value">￥{{params.ordermoney}}</div>
        </div>
        <div class="tips">购买提示：题库属虚拟产品，不支持退款服务，敬请谅解!</div>
        <div class="now-buy" @click="handleBuy">立即购买</div>
    </div>
</van-popup>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {uploadTopicQuestionBankOrder, getTopicQBBaseInfoAll} from '@/api/specialTopic.js'
import specialTopic from '@/common/js/specialTopic.json'
export default {
    data() {
        return {
            subjectlist: {},
            currentTopicIndex: 0,
            params: {
                bindsubjectcount: 1, // 绑定购买科目数，1-4
                clienttype: 1, // 客户端类型：1PC 2移动 3微信 4小程序 5App 
                discountmoney: '', // 折扣金额，单位分
                examcode: '', // 专题code
                ordermoney: '', // 订单金额，单位分 
                paymoney: '', // 实际支付金额，单位分
                resulturl: '', // 支付完成返回路径
                subjectcodes: '', // 科目Code，多个逗号分隔
                subjectnames: '', // 科目名称，多个逗号分隔
            }
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.subjectlist = JSON.parse(JSON.stringify(specialTopic.buySubjectList))
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(examcode, subjectcode) {
            this.setSpecialTopicBuyDialogVisible(true)
            this.handleInit(examcode ? examcode : 'jjcy', subjectcode)
        },
        handleClose() {
            this.setSpecialTopicBuyDialogVisible(false)
            this.params.examcode = ''
            this.params.subjectcodes = ''
            this.params.subjectnames = ''
        },
        handleInit(examcode, subjectcode) {
            this.params.examcode = examcode
            if (subjectcode) {
                this.params.subjectcodes = subjectcode
                this.subjectlist.some((item, index) => {
                    if (item.examcode === examcode) {
                        this.currentTopicIndex = index
                        item.subjectList.some(option => {
                            if (option.subjectcode === subjectcode) {
                                this.params.subjectnames = option.subjectname
                                return true
                            }
                        })
                        return true
                    }
                })
            } else {
                this.subjectlist.some((item, index) => {
                    if (item.examcode === examcode) {
                        this.currentTopicIndex = index
                        this.params.subjectcodes = item.subjectList[0].subjectcode
                        this.params.subjectnames = item.subjectList[0].subjectname
                        return true
                    }
                })
            }
            this.handleGetTopicQBBaseInfoAll()
        },
        handleChangeExamcode(item, index) {
            if (item.examcode !== this.params.examcode) {
                this.params.examcode = item.examcode
                this.currentTopicIndex = index
                this.handleChangeSubject(item.subjectList[0])
            }
        },
        handleChangeSubject(item) {
            if (this.params.subjectcodes !== item.subjectcode) {
                this.params.subjectcodes = item.subjectcode
                this.params.subjectnames = item.subjectname
                this.params.ordermoney = item.uprice
                this.params.bindsubjectcount = item.bindsubjectcount
            }
        },
        handleGetTopicQBBaseInfoAll() {
            this.setLoading(true)
            getTopicQBBaseInfoAll({
                data: {},
                success: data => {
                    data.data.forEach(item => {
                        this.subjectlist.some(option => {
                            if (option.examcode === item.examcode) {
                                option.subjectList.forEach(obj => {
                                    obj.uprice = item[obj.upricename]
                                    if (this.params.subjectcodes === obj.subjectcode) {
                                        this.params.ordermoney = obj.uprice
                                        this.params.bindsubjectcount = obj.bindsubjectcount
                                    }
                                })
                            }
                        })
                    })
                    this.setLoading(false)
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleBuy() {
            let params = JSON.parse(JSON.stringify(this.params))
            params.ordermoney = params.ordermoney * 100
            params.paymoney = params.ordermoney
            params.discountmoney = 0
            params.resulturl = location.origin + '/m/specialTopic' + `/${this.params.examcode}` + '/buyresult'
            this.setLoading(true)
            uploadTopicQuestionBankOrder({
                data: params,
                success: data => {
                    this.setLoading(false)
                    window.location.replace(data.data.url)
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        ...mapActions([
            'setSpecialTopicBuyDialogVisible',
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'specialTopicBuyDialogVisible'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.buy-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .content-scroll {
        height: calc(100vh - 0.88rem - 0.2rem - 2.6rem);
        background: #fff;
        margin: 0.1rem 0;
        .el-scrollbar__view {
            padding: 0.4rem 0.32rem;
            box-sizing: border-box;
            .module-name {
                display: flex;
                align-items: center;
                margin-bottom: 0.28rem;
                &::before {
                    content: '';
                    display: block;
                    width: 0.04rem;
                    height: 0.28rem;
                    margin-right: 0.15rem;
                    background: #1D60AD;
                }
                .name {
                    font-size: 0.32rem;
                    color: #333333;
                    line-height: 0.4rem;
                    font-weight: bold;
                }
            }
            .banklist {
                margin-bottom: 0.4rem;
                .bank-item {
                    padding: 0.1rem 0.2rem;
                    line-height: 0.36rem;
                    display: inline-block;
                    background: #F0F2F5;
                    border-radius: 0.04rem;
                    font-size: 0.26rem;
                    color: #333333;
                    margin-bottom: 0.28rem;
                    margin-right: 0.2rem;
                    &.active {
                        background: rgba(58,126,227,0.1);
                        color: #3A7EE3;
                    }
                }
            }
            .subjectlist {
                margin-bottom: 0.4rem;
                .subject-item {
                    display: flex;
                    .subject-item-label {
                        padding: 0.1rem 0.2rem;
                        line-height: 0.36rem;
                        display: block;
                        background: #F0F2F5;
                        border-radius: 0.04rem;
                        font-size: 0.26rem;
                        color: #333333;
                        margin-bottom: 0.28rem;
                        border: 0.01rem solid #F0F2F5;
                        &.active {
                            background: rgba(58,126,227,0.1);
                            color: #3A7EE3;
                            border: 0.01rem solid #3A7EE3;
                        }
                    }
                }
            }
            .expiredate {
                width: 2.85rem;
                height: 0.54rem;
                background: #FCF5E7;
                border-radius: 0.04rem;
                display: flex;
                align-items: center;
                padding: 0 0.2rem;
                font-size: 0.26rem;
                color: #785B18;
                position: relative;
                .select-icon {
                    width: 0.36rem;
                    height: 0.36rem;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }
        }
    }
    .order-info-handle {
        height: 2.6rem;
        padding: 0.28rem 0.24rem 0.13rem;
        box-sizing: border-box;
        background: #fff;
        .ordermoney {
            display: flex;
            align-items: center;
            margin-bottom: 0.1rem;
            .label {
                font-size: 0.28rem;
                color: #333333;
                line-height: 0.4rem;
            }
            .value {
                font-size: 0.38rem;
                color: #FA2B19;
                line-height: 0.54rem;
            }
        }
        .tips {
            font-size: 0.24rem;
            color: #FF3838;
            line-height: 0.34rem;
            margin-bottom: 0.25rem;
        }
        .now-buy {
            width: 100%;
            height: 0.88rem;
            background: linear-gradient( 90deg, #413E31 0%, #4E4A41 100%);
            border-radius: 1rem;
            text-align: center;
            line-height: 0.88rem;
            color: #F6D692;
            font-size: 0.32rem;
        }
    }
}
.van-overlay {
    background: #fff;
}
</style>